import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import './index.css'
import { routes } from './routes'
import { ThemeProvider } from '@/shared/ui'
import { initAnalytics } from '@/shared/lib'
// Side-effect import: applies the persisted `animate-on` root class before paint.
import '@/entities/settings'

initAnalytics(import.meta.env.VITE_UMAMI_ID)

const root = document.getElementById('root')
if (!root) throw new Error('Root element not found')

// A data router (rather than <BrowserRouter>/<Routes>) is what makes Link's
// `viewTransition` prop actually run document.startViewTransition.
const router = createBrowserRouter(routes)

function mount() {
  createRoot(root!).render(
    <StrictMode>
      <ThemeProvider defaultTheme="system" storageKey="dnd-theme">
        <RouterProvider router={router} />
      </ThemeProvider>
    </StrictMode>,
  )
}

// Let the browser paint the static app-shell (in index.html) once before React
// mounts and replaces it. Mounting synchronously would render the full app in
// the same frame, so First Contentful Paint would wait for this whole bundle to
// execute; yielding two frames lets the skeleton paint first. Negligible (~1
// frame) delay to interactivity.
requestAnimationFrame(() => requestAnimationFrame(mount))
